import { Trans } from '@lingui/react/macro';
import type { CustomerReferredFriendRecord } from '@navio/nsdk';
import { NoddiBadge } from 'noddi-ui-web';
import { toReferralStaffStatus, type ReferralStaffStatus } from 'noddi-web';

import { customerReferralStatusBadgeVariant, referralFriendStatusSubtext } from '../../utils/referralFriendDisplay';

type Props = {
  status: CustomerReferredFriendRecord['status'];
  friend?: CustomerReferredFriendRecord;
  labelMode?: 'short' | 'descriptive';
};

const statusLabel = (staffStatus: ReferralStaffStatus) => {
  if (staffStatus === 'successful') {
    return <Trans>Completed</Trans>;
  }
  if (staffStatus === 'expired') {
    return <Trans>Expired</Trans>;
  }
  return <Trans>Waiting</Trans>;
};

export const CustomerReferralStatusBadge = ({ status, friend, labelMode = 'short' }: Props) => {
  const staffStatus: ReferralStaffStatus = toReferralStaffStatus(status);
  const label =
    labelMode === 'descriptive' && friend != null
      ? referralFriendStatusSubtext(friend.status)
      : statusLabel(staffStatus);

  return <NoddiBadge variant={customerReferralStatusBadgeVariant(status)}>{label}</NoddiBadge>;
};
